import { render } from "./App.vue?vue&type=template&id=e475f844"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e475f844&lang=css"
script.render = render

export default script